import { inject, Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

import { HtmlSanitizerService } from '../security/html-sanitizer.service';

/** AIWB-1309 — author/config HTML for `[innerHTML]`, cleaned by the INLINE rule set (keeps class,
 *  style, inline SVG) before it is trusted. Never a blind bypass. */
@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  private readonly htmlSanitizer = inject(HtmlSanitizerService);

  transform(value: string | null | undefined): SafeHtml {
    return this.htmlSanitizer.trustInlineHtml(value);
  }
}
